import { getOffsets } from '../../util/indexOffsets';
import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';
import { FLUSH_ALIGN, getLineEnd, LINE_TYPE, SHOW_LINE, TEXT } from '../annotation';

function getShowLine(itemValue, globalValue) {
  if (itemValue !== undefined) {
    return itemValue;
  }
  if (globalValue !== undefined) {
    return globalValue;
  }
  return SHOW_LINE;
}

function convertAnnotations(chart) {
  const { sizes, data, type } = chart;
  const { seriesOffset, categoryOffset } = getOffsets(data);

  const { categories, series: allSeries } = data;
  const { annotations } = sizes.preview;
  const items = annotations ? annotations.items : [];

  return items.map((item) => {
    const pointEnabled = item.attach.point.enabled;
    const attachTo = pointEnabled ? 'point' : 'category';

    const currentLineEnd = item.lineEnd || annotations.lineEnd || getLineEnd(type);
    const lineEnd = currentLineEnd.toLowerCase();

    const flushAlign = item.flushAlign || annotations.flushAlign || FLUSH_ALIGN;
    const showLine = getShowLine(item.showLine, annotations.showLine);

    const lineType = item.lineType || LINE_TYPE;
    const text = item.text || TEXT;
    const series = allSeries[item.attach.point.series + seriesOffset].name;
    const catIdx = item.attach[attachTo].index;
    const category = categories[catIdx];

    // TODO: review naming
    const seriesIndex = item.attach.point.series + seriesOffset;
    const dataIndex = item.attach.point.index + categoryOffset;
    const value = allSeries[seriesIndex].data[dataIndex].y; // what is category enabled

    return { attachTo, lineEnd, flushAlign, showLine, lineType, text, series, category, value };
  });
}

function fetchAnnotationInfo(state, action) {
  if (!action.data) {
    return state;
  }

  const { body, status } = action.data;

  if (status === 'success') {
    const { items, annotationsChanged } = body.chart.data;

    return {
      annotationsChanged,
      items: items || convertAnnotations(body.chart),
    };
  }

  return state;
}

function updateChart(stateTree, state, items, annotationsChanged) {
  const { active } = stateTree.documents;

  // TODO: review this memory usage for other reducers as well
  // activeDoc is mutated to read only `.mustRender` afterwards
  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));
  localStorage.setItem('saved', 'false');

  if (items) {
    return { ...state, items, annotationsChanged, mustRender: activeDoc.mustRender };
  }

  return state;
}

export { fetchAnnotationInfo, updateChart };
